<template>
  <!DOCTYPE html><html>
    <head></head>
      <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
        <pre style="padding-bottom: 4px; font-family: 'Montserrat', sans-serif; font-size: 40px; font-weight:900; text-align: center; text-transform: uppercase;">Pase de Abordar</pre>
        <!--<span style="padding: 2px; font-size: 18px;">{{user.agencia_activa +' - '+ user.username +' -'}} <span>{{ boleto.created_at | moment('DD-MM-YYYY HH:mm') }}</span></span> -->
        <table style="border-collapse: collapse; width: 100%; font-size: 28px; text-align: left;">  
          <tr>    
            <td style="font-weight:800;">No de Pase: {{ boleto.id }}</td>
            <td style="font-weight:800;">No Asiento: {{ boleto.asiento }}</td>  
          </tr> 
          <tr>    
            <td style="padding: 2px; font-weight:600;">Nombre pasajero:</td>
            <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{boleto.nombre_pasajero}}</td>  
          </tr>  
          <tr>    
            <td style="padding: 2px; font-weight:600;">Origen:</td>
            <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{boleto.terminal_origen}}</td>  
          </tr>
          <tr>    
            <td style="padding: 2px; font-weight:600;">Destino:</td>
            <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{boleto.terminal_destino}}</td>  
          </tr>
          <tr>    
            <td style="padding: 2px; font-weight:600;">Fecha de viaje:</td>
            <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{boleto.fecha_salida | moment('dddd, DD/MM/YYYY')}}</td>  
          </tr>
          <tr>    
            <td style="padding: 2px; font-weight:600;">Hora de viaje:</td>
            <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{boleto.fecha_salida | moment('HH:mm')}} Hrs</td>  
          </tr>
          <tr>    
            <td style="padding: 2px; font-weight:600;">Tipo de servicio:</td>
            <td style="padding: 2px; text-transform: uppercase; font-weight:800;">
              <span v-if="(boleto.asiento === null)">Blanco</span>
              <span v-else>
                <span v-if="(boleto.categoria_asiento_id === 1)">Básica</span>
                <span v-if="(boleto.categoria_asiento_id === 2)">Ejecutiva</span>
                <span v-if="(boleto.categoria_asiento_id === 3)">Confort</span>
              </span>
            </td>  
          </tr>
          <tr>    
            <td style="padding: 2px; font-weight:600;">Tipo de pasajero:</td>
            <td v-if="boleto.descuento != undefined && boleto.descuento != null && boleto.descuento.valor != 0" style="padding: 2px; text-transform: uppercase; font-weight:800;">
              <span>{{ boleto.descuento.nombre }}</span>
            </td>
            <td v-else style="padding: 2px; text-transform: uppercase; font-weight:800;">
              <span>Adulto</span>
            </td> 
          </tr>
          <tr>    
            <td style="padding: 2px; font-weight:600;">Subida:</td>
            <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.paradero_origen }}</td>  
          </tr>
          <tr>    
            <td style="padding: 2px; font-weight:600;">Bajada:</td>
            <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ boleto.paradero_destino }}</td>  
          </tr>
          <tr>    
            <td style="padding: 2px; font-weight:600;">Importe:</td>
            <td style="padding: 2px; text-transform: uppercase; font-weight:800;">${{ boleto.monto_total_pagar }}</td>  
          </tr>
        </table>
        <p style="text-transform: uppercase; font-weight:800; font-size: 28px;">
          {{ boleto.resumen_pago }}
        </p>
        <table style="border-collapse: collapse; width: 100%; font-size: 28px; text-align: left;">  
          <tr>    
            <td style="margin-top: 20px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 20px; font-weight:600; text-align: left; text-transform: uppercase">
                {{user.username}}/{{boleto.created_at | moment('DDMMYYYY')}}/{{ boleto.created_at | moment('HH:mm') }} 
            </td>
            <td style="font-weight:800;">
              FOLIO: {{ boleto.clave_facturacion }}
            </td>  
          </tr> 
        </table>
        <pre style="margin-top: 4px; font-family: 'Montserrat', sans-serif; font-size: 18px; font-weight:600; text-align: center; text-transform: uppercase;">Para facturar, conoce el aviso de privacidad y nuestras políticas comerciales en www.platinumline.mx</pre>
      </body>
    </html>
</template>
<script>
export default {
props: {
  boleto: {required: false},
  user: {required: false},
},

mounted(){
},

data() {
    return {
     
    };
  },
}
</script>
<style scoped> 
</style>